import { render } from "./SelectClient.vue?vue&type=template&id=36713cab&scoped=true"
import script from "./SelectClient.vue?vue&type=script&lang=js"
export * from "./SelectClient.vue?vue&type=script&lang=js"

import "./SelectClient.vue?vue&type=style&index=0&id=36713cab&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36713cab"]])

export default __exports__